import { Validator } from '@vista-digital/validator';
export const defaultUpdateMemberCredentialPromptFormDisplayText = {
    actionButtonLabel: 'Change'
};
export const defaultUpdateEmailMemberCredentialFormDisplayText = Object.assign(Object.assign({}, defaultUpdateMemberCredentialPromptFormDisplayText), { fieldLabel: 'Email address' });
export const defaultUpdateUsernameMemberCredentialFormDisplayText = Object.assign(Object.assign({}, defaultUpdateMemberCredentialPromptFormDisplayText), { fieldLabel: 'Username' });
export const defaultUpdatePasswordMemberCredentialFormDisplayText = Object.assign(Object.assign({}, defaultUpdateMemberCredentialPromptFormDisplayText), { fieldLabel: 'Password' });
export const updateMemberCredentialPromptFormDisplayTextValidator = Validator.object({
    fieldLabel: Validator.nonEmptyString,
    actionButtonLabel: Validator.nonEmptyString
});
//# sourceMappingURL=display-text.js.map